import {
    CmsEditableFields,
    CmsFlexibleBackgroundFields,
    CmsHeadingFields,
    CmsTextOverlayFields,
} from '@activebrands/core-web/libs/storyblok/content/cms-module-content';
import { RawButtonData, RawSplitData } from '@activebrands/core-web/libs/storyblok/storyblok';
import extractBackgroundOverlays from '@activebrands/core-web/libs/storyblok/utils/extract-background-overlays';
import transformAnchorTag from '@activebrands/core-web/libs/storyblok/utils/transform-anchor-tag';
import { transformButton } from '@activebrands/core-web/libs/storyblok/utils/transform-buttons';
import { RawBackgroundData } from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-background';
import transformFlexibleBackgrounds from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-backgrounds';
import transformFlexibleBackgroundsFactors from '@activebrands/core-web/libs/storyblok/utils/transform-flexible-backgrounds-factors';
import transformHeading from '@activebrands/core-web/libs/storyblok/utils/transform-heading';
import transformLayout from '@activebrands/core-web/libs/storyblok/utils/transform-layout';
import transformParagraph from '@activebrands/core-web/libs/storyblok/utils/transform-paragraph';
import transformPreviewEditable from '@activebrands/core-web/libs/storyblok/utils/transform-preview-editable';
import transformTag from '@activebrands/core-web/libs/storyblok/utils/transform-tag';
import ShopTheLook from 'components/content-components/ShopTheLook';

export interface ShopTheLookProductSelection {
    component?: string;
    products?: unknown[];
}

export interface ShopTheLookContent
    extends CmsEditableFields, CmsFlexibleBackgroundFields, CmsHeadingFields, CmsTextOverlayFields {
    button?: RawButtonData[];
    productSelection?: ShopTheLookProductSelection[];
}

export interface ShopTheLookDataTransformerBlockProps {
    content?: ShopTheLookContent;
    isFourColumns?: boolean;
    isThreeColumns?: boolean;
    isTwoColumns?: boolean;
}

const ShopTheLookDataTransformerBlock = ({
    content = {},
    isFourColumns = false,
    isThreeColumns = false,
    isTwoColumns = false,
}: ShopTheLookDataTransformerBlockProps) => {
    const {
        _editable,
        _uid,
        anchorTag = [],
        backgroundDesktop = [],
        backgroundMobile = [],
        button = [],
        heading = [],
        tag = [],
        paragraph = [],
        productSelection = [],
        textColor,
    } = content;

    const backgrounds = [backgroundMobile[0], null, null, null, backgroundDesktop[0]] as (
        | RawBackgroundData
        | RawSplitData
    )[];

    const backgroundOverlays = extractBackgroundOverlays(backgrounds);
    const layout = transformLayout({ isTwoColumns, isThreeColumns, isFourColumns });
    const transformedBackgrounds = transformFlexibleBackgrounds(
        backgrounds,
        transformFlexibleBackgroundsFactors(layout)
    );
    const transformedButton = button?.[0] ? transformButton(button[0]) : undefined;

    return (
        <ShopTheLook
            background={transformedBackgrounds}
            backgroundOverlay={backgroundOverlays}
            buttonLabel={transformedButton?.label}
            buttonTheme={transformedButton?.theme}
            heading={transformHeading({ heading, defaultType: 'h3' })}
            id={transformAnchorTag({ anchorTag })}
            paragraph={transformParagraph({ paragraph })}
            products={productSelection?.[0]?.products}
            optiId={_uid}
            sbEditable={transformPreviewEditable(_editable)}
            tag={transformTag({ tag })}
            textColor={textColor}
        />
    );
};

export default ShopTheLookDataTransformerBlock;
